export default __webpack_public_path__ + "static/media/gazette notifications icon.4eba7b9f.svg";